"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proAdvertiseMessageSecondPart = exports.proAdvertiseMessageFirstPart = void 0;
exports.proAdvertiseMessageFirstPart = `🛡️ JavaScript Obfuscator Pro is now available — with powerful Virtual Machine-based obfuscation
(bytecode virtualization, anti-decompilation, unique opcode and VM structure each compilation, and more).`;
exports.proAdvertiseMessageSecondPart = '👉️ Get your API key at https://obfuscator.io and start using Virtual Machine obfuscation with javascript-obfuscator package.';
